module.exports = __webpack_public_path__ + "img/num01.490799a8.png";